import { render, staticRenderFns } from "./PatHomePage.vue?vue&type=template&id=365af4f1"
import script from "./PatHomePage.vue?vue&type=script&lang=js"
export * from "./PatHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports